import React from 'react';
import { List } from 'immutable';

class Toggle extends React.Component {
    constructor(props) {
        super(props);
        this.state = { extended: List()};
    }

    handleExtend = id => () => {
        const index = this.state.extended.indexOf(id);
        const newExtended = (index === -1)
            ? this.state.extended.push(id)
            : this.state.extended.delete(index);

        this.setState({ extended: newExtended })
    };

    isExtended = id => this.state.extended.includes(id);

    render = () => (this.props.children(this.isExtended, this.handleExtend))
}



export default Toggle;


// WEBPACK FOOTER //
// ./src/modules/clients/src/components/Toggle.js